import { store } from '../../store/store'
import vue from '../../main'
import base from "../../api/httpApi/base";
import { nanoid } from "nanoid";

let mixin = {
  data() {
    return {
      loginUser2: 12,
      uploadUrl: "",
      reportType: [{ val: 1, txt: "侵權內容" }, { val: 2, txt: "垃圾或誤導性內容" }, { val: 3, txt: "色情、暴力或惡意內容" }, { val: 4, txt: "我不喜歡這段影片" }, { val: 5, txt: "不當內容" }]
    };
  },
  methods: {
    getN() {
      return nanoid();
    },
    getSortLink(id, key = 'D') {
      return `${base.evi}/${key}${id}`;
    },
    checkIsMobile() {
      let sUserAgent = navigator.userAgent.toLowerCase();
      if (
        /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
          sUserAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    clearCookie(name) {
      this.setCookie(name, "", -1);
    },
    getCookiePar(cookieStr, name) {
      let result = "";
      const cookieList = cookieStr.split("&");
      for (let i = 0; i < cookieList.length; i++) {
        const key = cookieList[i].split("=")[0];
        if (key === name) {
          result = cookieList[i].split("=")[1];
          break;
        }
      }
      return result;
    },
    setCookie: function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      console.info(cname + "=" + cvalue + "; " + expires);
      document.cookie = cname + "=" + cvalue + "; " + expires;
      console.info(document.cookie);
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        // console.log(c);
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    historyPushState(url) {
      window.history.pushState(
        {},
        "",
        url
      );
    },
    historyReplaceState(url) {
      window.history.replaceState(
        {},
        "",
        url
      );
    },
    setUrlPar(obj) {
      let urlPar = this.getUrlPar();
      urlPar = Object.assign(urlPar, obj);
      let url = "";
      Object.keys(urlPar).forEach((item, ix, arr) => {
        if (ix === 0) {
          url += `?${item}=${urlPar[item]}`;
        } else {
          url += `&${item}=${urlPar[item]}`;
        }
      });
      return window.location.origin + window.location.pathname + url;
    },
    getUrlPar() {
      var url = location.search; //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    shareItem(id, type) {
      let urlb = escape(`/Home/facebookResp?id=${id}&type=${type}`);
      window.open(
        `${vue.$shareUrl}${base.url}${urlb}`,
        "_blank"
      );
    },
    urlHttpCheck(url) {
      if (!url.startsWith("https") && !url.startsWith("http")) {
        return `http://${url}`
      } else {
        return url;
      }
    },
    ClearObj(obj) {
      Object.keys(obj).forEach(key => {
        if (typeof (obj[key]) === 'number') {
          obj[key] = 0
        } else {
          obj[key] = ''
        }
      });
      return obj;
    },
    uploadImgCheck(file) {
      const isJPG = file.type === "image/jpeg";
      const ispng = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !ispng) {
        this.$message.error("圖片只能是 JPG /png格式!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("圖片大小不能超过 5MB!");
        return false;
      }
      return (isJPG || ispng) && isLt5M;
    },
    CheckUserIsLogin(fun) {
      if (this.loginUser == null) {
        if (fun) {
          if (typeof (fun) == "function") {
            fun()
          }
        }
        vue.$router.push({
          path: "/customerLogin",
          query: { redirect: vue.$route.fullPath },
        });
        return false
      }
      else {
        return true;
      }
    },
    GetReportType(val) {
      let result = "";
      for (let item in this.reportType) {
        if (this.reportType[item].val == val) {
          result = this.reportType[item].txt;
          break;
        }
      }
      if (result == "") result = val;
      return result;
    },
    IsNullOrEmpty(str) {
      if (str == null || str == undefined || str == '') {
        return true;
      }
      return false;
    },
    getCurrentTime() {
      //获取当前时间并打印
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
      return yy + '/' + mm + '/' + dd + ' ' + hh + ':' + mf + ':' + ss;
    },
    copyToClipboard(s, showMsg, msgContent) {
      var input = document.createElement("input");   // 直接构建input
      input.value = s;  // 设置内容
      document.body.appendChild(input);    // 添加临时实例
      input.select();   // 选择实例内容
      document.execCommand("Copy");   // 执行复制
      //document.body.removeChild(input);
      input.style.display = 'none';
      if (showMsg) {
        let msg = "複製成功";
        if (msgContent) {
          msg = msgContent;
        }
        this.$message({ type: "success", message: msg });
      }
      return
      if (window.clipboardData) {
        window.clipboardData.setData('text', s);
      } else {
        (function (s) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', s);
            e.preventDefault();
            document.oncopy = null;
          }
        })(s);
        document.execCommand('Copy');
      }
      if (showMsg) {
        let msg = "複製成功";
        if (msgContent) {
          msg = msgContent;
        }
        this.$message({ type: "success", message: msg });
      }
    }
  },
  created() {
    //this.loginUser = store.getters.getcustomer;
  },
  computed: {
    loginUser() {
      return store.getters.getcustomer;
    }
  }
};
export default mixin;


// WEBPACK FOOTER //
// ./src/assets/js/tools.js